import { useState } from 'react';
import { MdOutlineInfo } from "react-icons/md";
import DefaultSubmodelElementsRenderer from './renderers/page/DefaultSubmodelElementsRenderer';
import SubmodalDetailsModal from './modals/SubmodelDetailsModal';
import { useIntl } from 'react-intl';
import Config from '../config/Config';
import getLocalizedText from './Utils';
import SectionWrapper from './SectionWrapper';
import { getWidgetsForSubmodel } from "./renderers/widgets/SubmodelWidgetRegistry";

function SubmodelView({ submodel }) {
  const { mainColor } = Config.appearance;

  const intl = useIntl()
  const locale = intl.locale;
  const noDescAvailable = intl.formatMessage({ id: 'no_description_available' });

  const { idShort, description, displayName, submodelElements } = submodel;
  const [showModal, setShowModal] = useState(false);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  // Function to extract values from 'keys' (e.g., semanticId, etc.)
  const extractKeyValue = (keyArray) => {
    if (Array.isArray(keyArray) && keyArray[0]?.value) {
      return keyArray[0].value;
    }
    return "Unknown"; // Default value if no key is found
  };

  const displayNameToShow = getLocalizedText(displayName, idShort, locale);

  const descriptionText = getLocalizedText(description, noDescAvailable, locale);

  const widgets = getWidgetsForSubmodel(submodel);

  // Ensure submodelElements is an array and safely map over it
  const submodelElementsToRender = Array.isArray(submodelElements) ? submodelElements : [];

  return (
    <div>
      <SectionWrapper contentStyle={{ marginBottom: 0, padding: '20px 25px', borderRadius: "14px", backgroundColor: 'transparent' }}>
        <h5 className='text-break mb-2' style={{ margin: 0, padding: 0, color: "#333333", fontWeight: 600, fontSize: "1.2rem", letterSpacing: "0.3px" }}>
          {displayNameToShow}
          <MdOutlineInfo onClick={handleShow} style={{ cursor: 'pointer', color: mainColor, position: 'relative', top: '-2px', left: '8px' }} />
        </h5>

        <p className="text-break" style={{ margin: 0, padding: 0, fontSize: '16px', color: '#333' }}>
          {descriptionText}
        </p>
      </SectionWrapper>

      {/* Render all widgets if available */}
      {widgets.length > 0 && (
        <div className="mt-1 mb-5">
          {widgets.map((Widget, i) => (
            <Widget key={i} submodel={submodel} />
          ))}
        </div>
      )}

      <SubmodalDetailsModal
        show={showModal}
        handleClose={handleClose}
        submodel={submodel}
      />

      {/* Check if submodelElements is a valid array */}
      {submodelElementsToRender.length > 0 ? (
        submodelElementsToRender.map((element, index) => {
          // If element has a 'keys' field (e.g., for semanticId or references)
          const keyValue = element?.keys ? extractKeyValue(element.keys) : null;

          // If the element has a 'value' field (e.g., for Property value)
          const elementValue = element?.value || "No value available";

          return (
            <div key={index}>

              <DefaultSubmodelElementsRenderer
                element={{ ...element, keyValue, elementValue }}
              />
            </div>
          );
        })
      ) : (
        <div>No submodel elements available</div>
      )}
    </div>
  );
}

export default SubmodelView;
